Namespace('Monitoring.Reports.FacebookActivity')

class Monitoring.Reports.FacebookActivity.ReportView extends Backbone.View
  className: 'facebook-activity-report'

  initialize: (@options = {}) ->
    # just set @options

  render: ->
    @renderHeader()
    return this
  
  renderHeader: =>
    header = new Monitoring.Reports.FacebookActivity.HeaderView(@options)
    header.render()
    @$el.html(header.el)